import React from 'react';
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import PortletSpinner from "../../../../partials/layout/PortletSpinner";
import DataGridBase from "../../../../partials/layout/DataGridBase";
import { Badge } from "react-bootstrap";
import * as projectOrderCrud from '../../../../crud/projectOrder.crud';
import { notificationUniqueTagsFilterV3 } from "../../../../store/helpers/FilterHelper";
import CustomFieldHelper from "../../_Helpers/CustomFieldHelper";
import { withListPageProps } from '../../../../shared/hoc/withListPageProps';
import moment from 'moment';
import BaseListPage from '../../_CustomComponents/BaseListPage';

export const getBatchFormFields = (fields, replyFields, intl, paymentPeriods, calculationPeriods) => {
    const formFields = [
        {
            caption: intl.formatMessage({ id: 'GENERAL.FORMS.FIELD.SUBJECT' }),
            dataField: 'subject',
            required: true,
            dataType: 'string',
            min: 1,
            max: 250
        }
    ];
    if (fields.ProjectRelation.visible) {
        formFields.push({
            caption: fields.ProjectRelation.label,
            dataField: 'linkedprojectid',
            required: fields.ProjectRelation.required,
            dataType: 'integer',
        });
    }
    if (fields.ProjectOrderNumber.visible) {
        formFields.push({
            caption: fields.ProjectOrderNumber.label,
            dataField: 'projectordernumber',
            required: fields.ProjectOrderNumber.required,
            dataType: 'string',
            max: 250
        });
    }
    if (fields.PurchaseOrderValue.visible) {
        formFields.push({
            caption: fields.PurchaseOrderValue.label,
            dataField: 'purchaseordervalue',
            required: fields.PurchaseOrderValue.required,
            dataType: 'money',
        });
    }
    if (fields.ItqRelation.visible) {
        formFields.push({
            caption: fields.ItqRelation.label,
            dataField: 'instructiontoquoteid',
            required: fields.ItqRelation.required,
            dataType: 'integer',
        });
    }
    if (fields.Description.visible) {
        formFields.push({
            caption: fields.Description.label,
            dataField: 'description',
            required: fields.Description.required,
            dataType: 'long-string',
        })
    }
    if (fields.Comments.visible) {
        formFields.push({
            caption: fields.Comments.label,
            dataField: 'comments',
            required: fields.Comments.required,
            dataType: 'long-string',
        })
    }
    if (fields.ItemsList.visible) {
        formFields.push({
            caption: fields.ItemsList.label,
            dataField: 'pricelistdescription',
            required: fields.ItemsList.required,
            dataType: 'string',
        })
    }
    if (fields.TotalListPrice.visible) {
        formFields.push({
            caption: fields.TotalListPrice.label,
            dataField: 'pricelisttotal',
            required: fields.TotalListPrice.required,
            dataType: 'money',
        })
    }
    if (fields.CompensationDescription.visible) {
        formFields.push({
            caption: fields.CompensationDescription.label,
            dataField: 'compensationeventdescripton',
            required: fields.CompensationDescription.required,
            dataType: 'string',
        })
    }
    if (fields.TotalAssessed.visible) {
        formFields.push({
            caption: fields.TotalAssessed.label,
            dataField: 'compensationeventtotal',
            required: fields.TotalAssessed.required,
            dataType: 'money',
        })
    }
    if (fields.StartDate.visible) {
        formFields.push({
            caption: fields.StartDate.label,
            dataField: 'startdatedisplay',
            required: fields.StartDate.required,
            dataType: 'date',
        });
    }
    if (fields.CompletionDate.visible) {
        formFields.push({
            caption: fields.CompletionDate.label,
            dataField: 'completiondatedisplay',
            required: fields.CompletionDate.required,
            dataType: 'date',
        });
    }
    if (fields.DelayAmount.visible) {
        formFields.push({
            caption: fields.DelayAmount.label,
            dataField: 'delaydamagestotal',
            required: fields.DelayAmount.required,
            dataType: 'money',
        })
    }
    if (fields.DelayPaymentPeriod.visible) {
        formFields.push({
            caption: fields.DelayPaymentPeriod.label,
            dataField: 'delaydamagestype',
            required: fields.DelayPaymentPeriod.required,
            dataType: 'list',
            options: {
                dataSource: paymentPeriods,
            }
        })
    }
    if (fields.BonusRate.visible) {
        formFields.push({
            caption: fields.BonusRate.label,
            dataField: 'bonusrate',
            required: fields.BonusRate.required,
            dataType: 'integer'
        })
    }
    if (fields.BonusCalculationPeriod.visible) {
        formFields.push({
            caption: fields.BonusCalculationPeriod.label,
            dataField: 'bonuscalculationperiod',
            required: fields.BonusCalculationPeriod.required,
            dataType: 'list',
            options: {
                dataSource: calculationPeriods,
            }
        })
    }

    return formFields;
}
class ProjectListPage extends BaseListPage {
    constructor(props) {
        super(props);
        this.notificationsTagsEnabled = process.env.REACT_APP_COMMUNICATION_TAG_ENABLED === 'true' && props.contract.specifictags?.length > 0;
        this.notificationsRelsEnabled = process.env.REACT_APP_COMMUNICATION_REL_ENABLED === 'true';
        this.customFields = [];
        if (props.customFields) {
            if (props.customFields.COMMUNICATION && props.customFields.COMMUNICATION.length > 0) {
                this.customFields.push(...(props.customFields.COMMUNICATION.filter(cf => cf.includelisting)));
            }
            if (props.customFields.REPLY && props.customFields.REPLY.length > 0) {
                this.customFields.push(...(props.customFields.REPLY.filter(cf => cf.includelisting)));
            }
        }
        this.batchFormFields = getBatchFormFields(this.props.workflowItem.fields, this.props.workflowItem.replyFields, this.props.intl, this.props.paymentPeriods, this.props.calculationPeriods);
        this.state = {
            notifications: null,
            tags: null
        };
    }
    componentDidMount() {
        super.componentDidMount();
        this.fetchProjectOrders2();
    }

    // fetchProjectOrders = async () => {
    //     try {
    //         const { companyid, projectid, contractid } = this.props.contract;
    //         const { data: responseObj } = await projectOrderCrud.getProjectOrdersReduced(companyid, projectid, contractid, this.props.accessibleWfIds);
    //         let listData = notificationAggregateListTagsFilter(responseObj.aggregatelist);
    //         listData = (this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed === true) ?
    //             listData :
    //             listData.filter(ntf => ntf.showtasknotification === 1);
    //         let tagFilters = notificationUniqueTagsFilter(responseObj.uniquetags);
    //         this.setState({ notifications: listData, tags: tagFilters });
    //     } catch (error) {
    //         console.log(error)
    //         this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
    //     }
    // }

    fetchProjectOrders2 = async () => {
        try {
            const { companyid, projectid, contractid } = this.props.contract;
            const { data: responseObj } = await projectOrderCrud.getProjectOrderReduced2(
                companyid,
                projectid,
                contractid,
                this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed,
                this.props.accessibleWfIds);
            let notifications = CustomFieldHelper.MapDataListCustomFieldsToObjectPropertiesV2(responseObj);
            let tagFilters = notificationUniqueTagsFilterV3(this.props.communicationTags);
            this.setState({ notifications, tags: tagFilters });
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }
    onTableSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData.length > 0) {
            const data = selectedRowsData[0];
            this.props.navigate(this.props.workflowItem.paths.basePath + data.projectorderid);
        }
    }
    calculateUrl = (rowData) => {
        return this.props.workflowItem.paths.basePath + rowData.projectorderid;
    }
    renderStatusColumn = (cellInfo) => {
        let badgeVariant = cellInfo.data.showtasknotification === 1 ? 'success' : 'secondary';
        const displayText = this.calculateStatusValue(cellInfo.data);
        return (<Badge variant={badgeVariant}>{displayText}</Badge>);
    }
    calculateStatusValue = (rowData) => {
        return this.props.intl.formatMessage({ id: 'OPTIONS.STATUS.' + rowData.status });
    }

    render() {
        if (!this.state.notifications) {
            return (<PortletSpinner />);
        }
        const { fields } = this.props.workflowItem;

        const columns = [
            { resource: "GENERAL.FORMS.FIELD.ID", dataField: "referenceid", dataType: 'string', renderReferenceidLink: true },
            { resource: "GENERAL.FORMS.FIELD.SUBJECT", dataField: "subject" },
            { resource: "GENERAL.FORMS.FIELD.NOTIFIED_BY", dataField: "communicatedby" },
            { resource: "GENERAL.FORMS.FIELD.NOTIFIED_DATE", dataField: "notificationdate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.CREATED_BY", dataField: "createby", visible: false },
            { resource: "GENERAL.FORMS.FIELD.DRAFT_NOTIFIED_TO", dataField: "lastdraftednotifiedtoname", visible: false },

        ];
        if (this.props.CENProjectOrderOptionEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.FIELD.REVISIED.START.DATE", dataField: "revisedstartdate", dataType: 'date' },
                { resource: "GENERAL.FORMS.FIELD.REVISIED.COMPLETION.DATE", dataField: "revisedcompletiondate", dataType: 'date' },
                { resource: "GENERAL.FORMS.FIELD.REVISIED.TOTAL.PRICES", dataField: "revisedprojectordertotal", dataType: 'currency', currencyCode: this.props.contract.currency },
                { resource: "GENERAL.FORMS.FIELD.CURRENT_START_DATE", dataField: "currentstartdate", dataType: 'date' },
                { resource: "GENERAL.FORMS.FIELD.CURRENT_COMPLETION_DATE", dataField: "currentcompletiondate", dataType: 'date' },
                { resource: "GENERAL.FORMS.FIELD.CURRENT_TOTAL_PRICES", dataField: "currentprojectordertotal", dataType: 'currency', currencyCode: this.props.contract.currency },

            );
        }
        if (fields.Description.visible) {
            columns.push(
                { caption: fields.Description.label, dataField: "description", isHtml: true, visible: false },
            );
        }
        if (fields.ItemsList.visible) {
            columns.push(
                { caption: fields.ItemsList.label, dataField: "pricelistdescription", visible: false },
            );
        }
        if (fields.TotalListPrice.visible) {
            columns.push(
                { caption: fields.TotalListPrice.label, dataField: "pricelisttotal", dataType: 'currency', currencyCode: this.props.contract.currency, visible: false },
            );
        }
        if (fields.CompensationDescription.visible) {
            columns.push(
                { caption: fields.CompensationDescription.label, dataField: "compensationeventdescripton", visible: false },
            );
        }
        if (fields.TotalAssessed.visible) {
            columns.push(
                { caption: fields.TotalAssessed.label, dataField: "compensationeventtotal", dataType: 'currency', currencyCode: this.props.contract.currency, visible: false },
            );
        }
        if (fields.TotalPrice.visible) {
            columns.push(
                { caption: fields.TotalPrice.label, dataField: "projectordertotal", dataType: 'currency', currencyCode: this.props.contract.currency },
            );
        }
        if (fields.StartDate.visible) {
            columns.push(
                { caption: fields.StartDate.label, dataField: "startdate", dataType: 'date' },
            );
        }
        if (fields.CompletionDate.visible) {
            columns.push(
                { caption: fields.CompletionDate.label, dataField: "completiondate", dataType: 'date' },
            );
        }
        if (fields.DelayAmount.visible) {
            columns.push(
                { caption: fields.DelayAmount.label, dataField: "delaydamagestotal", dataType: 'currency', currencyCode: this.props.contract.currency, visible: false }
            );
        }
        if (fields.DelayPaymentPeriod.visible) {
            columns.push(
                { caption: fields.DelayPaymentPeriod.label, dataField: "delaydamagestype", visible: false }
            );
        }
        if (fields.BonusRate.visible) {
            columns.push(
                { caption: fields.BonusRate.label, dataField: "bonusrate", dataType: 'currency', currencyCode: this.props.contract.currency, visible: false }
            );
        }
        if (fields.BonusCalculationPeriod.visible) {
            columns.push(
                { caption: fields.BonusCalculationPeriod.label, dataField: "bonuscalculationperiod", visible: false }
            );
        }

        columns.push(
            { resource: "GENERAL.FORMS.FIELD.STATUS", dataField: "status", cellRender: this.renderStatusColumn, calculateCellValue: this.calculateStatusValue },
            { resource: "GENERAL.FORMS.FIELD.LINK", dataField: "url", calculateCellValue: this.calculateUrl, visible: false, showInColumnChooser: false },
            { resource: "PROJECT.FIELD.CODE", dataField: "projectcode", visible: false },
            { resource: "PROJECT.FIELD.NAME", dataField: "project", visible: false }
        );
        if (this.props.workflowItem.assetFieldsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.FIELD.ASSET_NAME", dataField: "assetname", visible: false },
                { resource: "GENERAL.FORMS.FIELD.ASSET_TYPE", dataField: "assettype", visible: false },
            );
        }
        if (this.props.contract.ispackaged) {
            if (fields.ProjectRelation.visible) {
                columns.push(
                    { resource: "CONTRACT.FIELD.LINKED_PROJECT_NAME", dataField: "linkedprojectname", visible: false },
                    { resource: "CONTRACT.FIELD.LINKED_PROJECT_CODE", dataField: "linkedprojectcode", visible: false },
                );
            }
            if (fields.ProjectOrderNumber.visible) {
                columns.push(
                    { caption: fields.ProjectOrderNumber.label, dataField: "projectordernumber", visible: false },
                );
            }
            if (fields.PurchaseOrderValue.visible) {
                columns.push(
                    { caption: fields.PurchaseOrderValue.label, dataField: "purchaseordervalue", dataType: 'currency', currencyCode: this.props.contract.currency, visible: false },
                );
            }
        }
        if (this.notificationsTagsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.FIELD.PORTFOLIO", dataField: "tags_portfolio", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.PortfolioFilter } },
                { resource: "GENERAL.FORMS.FIELD.PROGRAMME", dataField: "tags_programme", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.ProgrammeFilter } },
                { resource: "GENERAL.FORMS.FIELD.PROJECT", dataField: "tags_project", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.ProjectFilter } },
                { resource: "GENERAL.FORMS.FIELD.OTHER", dataField: "tags_other", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.OtherFilter } }
            )
        }
        if (this.notificationsRelsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.TAB_RELATIONS", dataField: "relatednotices", visible: false },
            )
        }
        if (this.props.projectOrderCertifiedStartDateFieldName) {
            columns.push(
                { caption: this.props.intl.formatMessage({ id: 'GENERAL.REGISTER.FIELD.PARTY.CERTIFIEDDATE' }, { PARTY: this.props.globalResources.SUPPLIER_NAME, CERTIFIED_DATE: this.props.projectOrderCertifiedStartDateFieldName }), dataField: "suppliercertifiedstartdate", dataType: 'date', visible: false },
                { caption: this.props.intl.formatMessage({ id: 'GENERAL.REGISTER.FIELD.PARTY.CERTIFIEDDATE' }, { PARTY: this.props.globalResources.PM_NAME, CERTIFIED_DATE: this.props.projectOrderCertifiedStartDateFieldName }), dataField: "pmcertifiedstartdate", dataType: 'date', visible: false },
                { caption: this.props.intl.formatMessage({ id: 'GENERAL.REGISTER.FIELD.PARTY.CERTIFIEDDATE' }, { PARTY: this.props.globalResources.SUPERVISOR_NAME, CERTIFIED_DATE: this.props.projectOrderCertifiedStartDateFieldName }), dataField: "supervisorcertifiedstartdate", dataType: 'date', visible: false },
                { caption: this.props.intl.formatMessage({ id: 'GENERAL.REGISTER.FIELD.PARTY.CERTIFIEDDATE' }, { PARTY: this.props.globalResources.CLIENT_NAME, CERTIFIED_DATE: this.props.projectOrderCertifiedStartDateFieldName }), dataField: "clientcertifiedstartdate", dataType: 'date', visible: false }
            );
        }
        if (this.props.projectOrderCertifiedCompletionDateFieldName) {
            columns.push(
                { caption: this.props.intl.formatMessage({ id: 'GENERAL.REGISTER.FIELD.PARTY.CERTIFIEDDATE' }, { PARTY: this.props.globalResources.SUPPLIER_NAME, CERTIFIED_DATE: this.props.projectOrderCertifiedCompletionDateFieldName }), dataField: "suppliercertifiedcompletiondate", dataType: 'date', visible: false },
                { caption: this.props.intl.formatMessage({ id: 'GENERAL.REGISTER.FIELD.PARTY.CERTIFIEDDATE' }, { PARTY: this.props.globalResources.PM_NAME, CERTIFIED_DATE: this.props.projectOrderCertifiedCompletionDateFieldName }), dataField: "pmcertifiedcompletiondate", dataType: 'date', visible: false },
                { caption: this.props.intl.formatMessage({ id: 'GENERAL.REGISTER.FIELD.PARTY.CERTIFIEDDATE' }, { PARTY: this.props.globalResources.SUPERVISOR_NAME, CERTIFIED_DATE: this.props.projectOrderCertifiedCompletionDateFieldName }), dataField: "supervisorcertifiedcompletiondate", dataType: 'date', visible: false },
                { caption: this.props.intl.formatMessage({ id: 'GENERAL.REGISTER.FIELD.PARTY.CERTIFIEDDATE' }, { PARTY: this.props.globalResources.CLIENT_NAME, CERTIFIED_DATE: this.props.projectOrderCertifiedCompletionDateFieldName }), dataField: "clientcertifiedcompletiondate", dataType: 'date', visible: false }
            );
        }

        columns.push(...CustomFieldHelper.MapCustomFieldsToDataGridColumns(this.customFields));

        return (
            <Portlet>
                <PortletBody>
                    <DataGridBase
                        version="3"
                        //BATCH OPS
                        batchOperations={true}
                        batchFormFields={this.batchFormFields}
                        batchImportEndpoint={projectOrderCrud.importProjectOrders}
                        batchDeleteEndpoint={projectOrderCrud.deleteProjectOrderDrafts}
                        batchCommunicateEndpoint={projectOrderCrud.communicateProjectOrderDrafts}
                        onBatchRecordsUpdated={this.fetchProjectOrders2}
                        customFields={this.props.customFields}
                        //BATCH OPS
                        title={this.props.intl.formatMessage({ id: 'GENERAL.REGISTER.TITLE2' }, { ITEM_NAME: this.props.workflowItem.pageTitle })}
                        createPath={this.props.workflowItem.userFilters.mainNotice.createAllowed ? this.props.workflowItem.paths.createPath : null}
                        workflowItem={this.props.workflowItem}
                        name={this.props.workflowItem.pageTitle}
                        dataSource={this.state.notifications}
                        keyExpr="projectorderid"
                        onSelectionChanged={this.onTableSelectionChanged}
                        hoverStateEnabled={true}
                        rowAlternationEnabled={false}
                        columns={columns}
                    />
                </PortletBody>
            </Portlet>
        );
    }
}

export default withListPageProps(ProjectListPage);
